import React from "react";

import "./legal.css"

export default function ImprintPage() {
    return <div className="page legal-page keep-margin">
        <h1>Imprint</h1>
        <div className="block">
            <h3>Service Provider within the meaning of §5 TMG:</h3>
            <p>vueste UG</p>
            <p>Jella-Lepman-Str. 22 z.H. Jorma Bissinger</p>
            <p>81673 Munich</p>
            <p>Germany</p>
        </div>
        <div className="block">
            <h3>Contact Information:</h3>
            <p>Email: <a href="mailto:info@vueste.de">info@vueste.de</a></p>
            <p>81673 München</p>
            <p>Germany</p>
        </div>
        <div className="block">
            <h3>Authorized Representive:</h3>
            <p>Jorma Bissinger</p>
            <p>Bela Brichzin</p>
        </div>
        <div className="block">
            <p>Registered Office: Germany</p>
            <p>Court of registration: Amtsgericht München</p>
            <p>Trade register number: HRB 295780</p>
        </div>
    </div>
}